import { z } from 'zod';

/** Shared MIME attachment metadata for received messages and saved drafts. */
export const GmailAttachmentMetadataSchema = z.object({
  attachment_id: z.string(), name: z.string(), content_type: z.string(),
  size: z.number().nonnegative(), inline: z.boolean(),
}).strict();

/** Draft containers have opaque API IDs; UI/sync references must never be substituted. */
export const GmailDraftIdSchema = z.string().min(1).max(1024).regex(/^[A-Za-z0-9_-]+$/);
export const GmailDraftReadParamsSchema = z.object({ draftId: GmailDraftIdSchema }).strict();
export const GmailDraftAttachmentReadParamsSchema = GmailDraftReadParamsSchema.extend({
  messageId: z.string().min(1).max(128).regex(/^[0-9a-f]+$/),
  partId: z.string().min(1).max(1024).regex(/^[A-Za-z0-9_-]+(?:\.[A-Za-z0-9_-]+)*$/),
}).strict();
export const GmailDraftMetadataResponseSchema = z.object({
  messageId: GmailDraftAttachmentReadParamsSchema.shape.messageId,
  attachments: z.array(GmailAttachmentMetadataSchema),
}).strict();
export type GmailDraftMetadataResponse = z.infer<typeof GmailDraftMetadataResponseSchema>;
